export const LANGUAGES = [
    { value: 'fr_FR', locale: 'fr-FR', text: 'Français (FR)' },
    { value: 'fr_CA', locale: 'fr-CA', text: 'Français (CA)' },
    { value: 'en_GB', locale: 'en-US', text: 'English (GB)' },
    { value: 'en_CA', locale: 'en-CA', text: 'English (CA)' },
    { value: 'en_US', locale: 'en-US', text: 'English (US)' },
    { value: 'en_ES', locale: 'es-ES', text: 'Español (ES)' },
    { value: 'it_IT', locale: 'it-IT', text: 'Italiano (IT)' },
    { value: 'nl_NL', locale: 'nl-NL', text: 'Nederlands (NL)' },
    { value: 'de_DE', locale: 'de-DE', text: 'Deutsch (DE)' }
];

export const getLanguagesOptions = () => LANGUAGES.map(({ text, value }) => ({ label: text, value }));

export const getLocale = locale => {
    if (!locale) return 'fr_FR';
    if (!locale.includes('-')) return `${locale}_${locale.toUpperCase()}`;
    return locale;
};

export const defaultLocale = lang => LANGUAGES.find(({ locale }) => locale === lang)?.locale || 'fr-FR';
